<template>
  <div class="newsMain">
    <div class="header">
      <div class="leftPart">
        <img src="@/assets/keben1.png" alt="" style="width:27px;height:27px;">
        <div class="text">图文报道</div>
      </div>
      <div class="titleLine"></div>
      <div class="rightPart"  @click="toList">更多+</div>
    </div>
    <div v-if="Data[0]" class="listPart">
      <div v-for="(item,index ) in Data[0].list" :key="index" class="itemPart"  @click="toDetail(item)">
        <div class="img">
          <img style="width:100%;height:100%;" :src="item.url"></img>
        </div>
        <div class="title">{{item.title}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  props: {
    Data: Array
  },
  methods: {
    toList(){
      this.$router.push(`/Content?type=${this.Data[0].title}&typeId=${this.Data[0].typeId}`)
    },
    toDetail(item){
      var routeData = this.$router.resolve({
        name: `Content`,
        query: {
          type:this.Data[0].title,
          typeId:this.Data[0].typeId,
          articleId: item.id
        }
      });
      window.open(routeData.href, '_blank');
    }
  },
  mounted() {

  },
  data() {
    return {
    };
  },
};
</script>

<style>
.newsMain{
  width: 100%;
  padding: 15px 10px;
  background: #fff;
}
.newsMain .header{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.newsMain .header .titleLine{
  width: 100%;
  height: 1px;
  background: #dcdcdc;
}
.newsMain .header .rightPart{
  width: 60px;
  cursor: pointer;
  font-size: 15px;
  color: #999;
  text-align: right;
}
.newsMain .header .leftPart{
  display: flex;
  align-items: center;
  width: 180px;
}
.newsMain .header .leftPart .text{
  font-size: 18px;
  margin-left: 10px;
}
.newsMain .listPart{
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 10px;
}
.newsMain .listPart .itemPart:hover{
  cursor: pointer;
  background: #034f92;
  color: #fff;
}
.newsMain .listPart .img{
  width: 220px;
  height: 150px;
  overflow: hidden;
  background: skyblue;
}
@keyframes mymove{
    0%{
    transform: scale(1);  /*开始为原始大小*/
    }
    100%{
        transform: scale(1.3); /*放大1.1倍*/
    }
}
.newsMain .listPart img:hover {
  animation-name: mymove;
      animation-direction: alternate;
      animation-timing-function: linear;
      animation-duration: 0.5s;
      animation-fill-mode : forwards ;
      -webkit-animation-fill-mode : forwards ;
}
.newsMain .listPart .title{
  width: 178px;
  line-height: 38px;
  height: 38px;
  border: 1px solid #dcdcdc;
  padding: 0 20px;
  margin-top: -5px;
  text-align: center;
  text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    line-clamp: 1;
    -webkit-box-orient: vertical;
}
</style>
